import type { TimelineItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import type { TimelineDateStyle } from "web_myplann/NotificationCenter/Types/TimelineDateStyle";
import { mapTimelineEntryDateLine } from "web_myplann/NotificationCenter/Utils/mapTimelineEntryDateLine";

export const useTimelineEntryDateLine = (
	item: TimelineItemResponseDTO,
	dateStyle: TimelineDateStyle,
): string => {
	const { t } = useResource();

	return mapTimelineEntryDateLine(item, dateStyle, t);
};
